import api from "./api";
import env from "../Config/env";

/**
 * Logomarca da agência — API real (upload em filesystem; servida estaticamente).
 *   GET  /api/v1/agency/logo            -> { logoUrl | null }
 *   POST /api/v1/agency/logo            -> multipart, campo `logo` -> { logoUrl }
 *   POST /api/v1/agency/logo/remove     -> { success }
 * `logoUrl` é um path (ex.: /uploads/agency-logos/9.png) — prefixar com o host da API.
 */

export const absoluteLogoUrl = (path) => {
	if (!path) return null;
	if (/^https?:\/\//i.test(path)) return path;
	return `${env.API_URL}${path}`;
};

export const getAgencyLogoUrl = async () => {
	const data = await api.get("/api/v1/agency/logo").then((r) => r.data);
	return absoluteLogoUrl(data.logoUrl);
};

export const uploadAgencyLogo = async (file) => {
	const fd = new FormData();
	fd.append("logo", file);
	// axios define o Content-Type multipart (com boundary) automaticamente p/ FormData.
	const data = await api.post("/api/v1/agency/logo", fd).then((r) => r.data);
	return absoluteLogoUrl(data.logoUrl);
};

export const removeAgencyLogo = async () => {
	await api.post("/api/v1/agency/logo/remove", {}).then((r) => r.data);
};
